module.exports = __webpack_public_path__ + "img/leaves-8184621_1280.bf48b9e3.png";